import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { NitroButton, NitroButtonGroup } from 'nitro-components';

import styled from 'styled-components';

import Container from '../../../../components/layouts/Container';

import FilterSection from './components/FilterSection';

const Content = styled.div`margin: 30px 0;`;

const isLastFilterEmpty = filters => {
  console.log(filters);
  if (filters.length === 0) {
    return true;
  }
  const lastFilterGroup = filters[filters.length - 1];
  if (lastFilterGroup.length === 0) {
    return true;
  }
  const lastFilter = lastFilterGroup[lastFilterGroup.length - 1];
  if (lastFilter.value === '') {
    return true;
  }
  return false;
};

export default class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: [...props.filters]
    };
  }

  // componentWillMount() {
  //   const filters = [...this.state.filters];
  //   if (filters.length === 0) {
  //     filters.push([
  //       {
  //         operator: 'include',
  //         field: 1,
  //         condition: 1,
  //         value: '',
  //         index: Date.now()
  //       }
  //     ]);
  //     this.setState({ filters });
  //   }
  // }

  componentDidMount() {
    this.setNavigation(isLastFilterEmpty(this.state.filters));
  }

  // TODO: Find a better way to add and remove default filter
  componentDidUpdate(previousProps, previousState) {
    const filters = [...this.state.filters];
    if (filters.length === 0) {
      this.addFilterSection();
      this.setNavigation();
    }
  }

  setNavigation = () => {
    const disabled = isLastFilterEmpty(this.state.filters);
    this.props.setNavigation({
      left: (
        <NitroButton
          outlined
          variant="secondary"
          action={this.props.navigation.goPrevious}
          label="PREVIOUS"
          size="extraSmall"
          leftIcon="arrow-left"
          insideIconSize={8}
          leftIconVariant="secondary"
        />
      ),
      middle: null,
      right: (
        <NitroButtonGroup layout="horizontal" align="right">
          <NitroButton
            action={this.props.navigation.goNext}
            label="SKIP"
            labelVariant="primary"
            size="extraSmall"
            rightIcon="arrow-right"
            rightIconVariant="primary"
            insideIconSize={8}
          />
          <NitroButton
            disabled={disabled}
            action={this.goNext}
            label="NEXT"
            variant="primary"
            size="extraSmall"
            rightIcon="arrow-right"
            insideIconSize={8}
          />
        </NitroButtonGroup>
      )
    });
  };

  setFilters = filters => {
    this.setState({ filters }, () => {
      this.setNavigation();
    });
  };

  goNext = () => {
    // Remove last empty
    this.props.actions.setFilters(this.state.filters);
    this.props.navigation.goNext();
  };

  addFilterSection = () => {
    const filters = [...this.state.filters];
    filters.push([
      {
        rule: 1,
        field: null,
        operator: null,
        value: '',
        index: _.uniqueId('frule_'),
      }
    ]);
    this.setFilters(filters);
  };

  addFilterToSection = () => {
    const filters = [...this.state.filters];
    const lastFilters = filters[filters.length - 1];
    lastFilters.push({
      rule: 1,
      field: null,
      operator: null,
      value: '',
      index: _.uniqueId('frule_'),
    });
    this.setFilters(filters);
  };

  removeFilterSection = groupIndex => {
    const filters = [...this.state.filters];
    filters.splice(groupIndex, 1);
    this.setFilters(filters);
  };

  updateFilterSection = (index, filter) => {
    const filters = [...this.state.filters];
    filters[index] = filter;
    this.setFilters(filters);
  };

  render() {
    const { filters } = this.state;

    return (
      <Container>
        <Content>
          {filters.map((filter, groupIndex) =>
            <FilterSection
              key={groupIndex}
              groupIndex={groupIndex}
              isLast={groupIndex === filters.length - 1}
              filter={filter}
              addFilterSection={this.addFilterSection}
              updateFilterSection={this.updateFilterSection}
              removeFilterSection={this.removeFilterSection}
              addFilter={this.addFilterToSection}
              removeFilterFromSection={this.removeFilterFromSection}
            />
          )}
        </Content>
      </Container>
    );
  }
}

Filters.propTypes = {};



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Filters/Filters.js